export const ADD_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST =
  'ADD_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST';
export const EXCHANGE_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST =
  'EXCHANGE_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST';
export const EDIT_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST =
  'EDIT_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST';
export const DELETE_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST =
  'DELETE_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST';
export const PROCESS_CLUB_MEMBER_SHIPMENT_REQUEST =
  'PROCESS_CLUB_MEMBER_SHIPMENT_REQUEST';
export const SKIP_CLUB_MEMBER_SHIPMENT_REQUEST =
  'SKIP_CLUB_MEMBER_SHIPMENT_REQUEST';
export const UNSKIP_CLUB_MEMBER_SHIPMENT_REQUEST =
  'UNSKIP_CLUB_MEMBER_SHIPMENT_REQUEST';

export const GET_CLUB_MEMBER_SHIPMENT_SUCCESS =
  'GET_CLUB_MEMBER_SHIPMENT_SUCCESS';
